import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import './AsyncModel.scss';

export const Popup = ({
  title,
  msg,
  footerMsg,
  content,
  showCancelBtn = false,
  showConfirmBtn = true,
  cancelBtnText = '取消',
  confirmBtnText = '確認',
  autoClose = false,
  autoCloseTime = 3000,
  onConfirm,
  onCancel,
  titleClass
}) => {
  return (
    <div className="popup">
      <div className="popup__body p-4">
        {title && <div className={`popup__header mb-2 mt-2 ${titleClass}`}>{title}</div>}
        <div className="popup__content">
          {msg && <div className="mb-2 mt-2">{msg}</div>}
          {content && <div className="mb-2 mt-2">{content}</div>}
        </div>
        <div className="popup__footer p-2">
          {showCancelBtn && (
            <a
              className="popup__btn popup__btn_white p-1 pl-3 pr-3"
              onClick={() => {
                onCancel();
              }}
            >
              {cancelBtnText}
            </a>
          )}
          {showConfirmBtn && (
            <a
              className="popup__btn popup__btn_red p-1 pl-3 pr-3"
              onClick={() => {
                onConfirm();
              }}
            >
              {confirmBtnText}
            </a>
          )}
          {footerMsg && <div>{footerMsg}</div>}
        </div>
      </div>
    </div>
  );
};

// 移除先前動態產生的 Component、Element
const unsetModel = wrap => {
  ReactDOM.unmountComponentAtNode(wrap);
  wrap.remove();
};
// 動態產生div
const createWrap = Id => {
  let wrap = document.getElementById(Id);
  if (wrap === null) {
    wrap = document.body.appendChild(document.createElement('div'));
    wrap.id = Id;
  }
  return wrap;
};
// 組合component&promise
const promiseHOC = (Component, option) => {
  const wrap = createWrap('asyncModelWrap');
  const promise = new Promise((response, reject) => {
    ReactDOM.render(
      <Component onConfirm={response} onCancel={reject} {...option} />,
      wrap
    );
    if(option.autoClose){
      setTimeout(()=>{
        response();        
      },option.autoCloseTime);
    }
  });
  return promise.then(
    // click confirm
    () => {
      unsetModel(wrap);
      return true;
    },
    // click cancel
    () => {
      unsetModel(wrap);
      return false;
    }
  );
};

// close
export const AsyncModelClose = function () {
  const wrap = createWrap('asyncModelWrap');
  return unsetModel(wrap)
}
// combine
export const AsyncModel = option => promiseHOC(Popup, option);
